import { BaseConfigurationDrawer } from '@terminal/components/base-configuration-drawer/BaseConfigurationDrawer';
import { queryValues } from '@terminal/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useFeedFilters } from '@terminal/stores/use-feed-filters/useFeedFilters';
import { EventFeedSortMenu } from '@terminal/views/insight-feed/components/event-feed-sort-dropdown/EventFeedSortDropdown';
import { useTranslation } from 'react-i18next';

import { PeriodChanger } from '../period-changer/PeriodChanger';
import styles from './WhatsNewSettingsDrawer.module.scss';

export const WhatsNewSettingsDrawer = () => {
  const { t } = useTranslation(['whatsNew', 'stream']);
  const { whatsNewSort, whatsNewSortOptionId, setWhatsNewSort } =
    useFeedFilters(state => ({
      whatsNewSort: state.whatsNewSort,
      whatsNewSortOptionId: state.whatsNewSortOptionId,
      setWhatsNewSort: state.setWhatsNewSort,
    }));

  const headerSection = (
    <div className={styles.headerSection}>
      <h3 className={styles.drawerTitle}>{t('whatsNew:drawer.title')}</h3>
      <div className={styles.settingsRow}>
        <span className={styles.settingLabel}>
          {t('whatsNew:drawer.timeRange', 'Time range')}
        </span>
        <PeriodChanger />
      </div>
      <div className={styles.sortSetting}>
        <div className={styles.settingsRow}>
          <span className={styles.settingLabel}>
            {t('whatsNew:drawer.sortOrder', 'Sort order')}
          </span>
          <EventFeedSortMenu
            sort={whatsNewSort}
            sortOptionId={whatsNewSortOptionId}
            onSelect={setWhatsNewSort}
            label={t('whatsNew:drawer.sortOrder', 'Sort order')}
            triggerTestId="whats-new-sort-trigger"
          />
        </div>
        <p className={styles.description}>
          {t(
            'whatsNew:drawer.sortInheritance',
            'Insights uses this sort order unless you choose another there.'
          )}
        </p>
      </div>
    </div>
  );

  return (
    <BaseConfigurationDrawer
      trackingSource={POSTHOG_TRACKING_SOURCES.WHATS_NEW_WIDGET}
      activeDrawer={queryValues.whatsNewSettingsDrawer}
      headerSection={headerSection}
      testId="whats-new-settings-drawer"
    />
  );
};
